// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_df-j";
export var fulfillmentFormRail = "_df-i";
export var headerTitleRow = "_df-l";
export var orderDetailsWrapper = "_df-g";
export var orderLinkTrigger = "_df-2";
export var paymentInformationGrid = "_df-q";
export var paymentSummaryColumn = "_df-r";
export var phoneShipmentPickerButton = "_df-e";
export var phoneShipmentPickerButtonContent = "_df-f";
export var phoneShipmentPickerButtonWrapper = "_df-d";
export var phoneShipmentPickerTrigger = "_df-c";
export var shipmentContainer = "_df-k";
export var shipmentDetailsMainPane = "_df-h";
export var shipmentNavigationCard = "_df-a";
export var shipmentNavigationEdgeTrigger = "_df-6";
export var shipmentNavigationRail = "_df-3";
export var shipmentNavigationRailEnter = "_df-5";
export var shipmentNavigationRailHeader = "_df-9";
export var shipmentNavigationRailOverlay = "_df-4";
export var shipmentNavigationScrim = "_df-7";
export var shipmentSummaryFact = "_df-n";
export var shipmentSummaryGrid = "_df-m";
export var shipmentSummaryMetadataRow = "_df-o";
export var shipmentSummaryTags = "_df-p";
export var shipmentWorkspace = "_df-0";
export var shipmentWorkspaceBodyTablet = "_df-8";
export var shipmentWorkspaceContent = "_df-b";
export var shipmentWorkspaceHeader = "_df-1";